<!--<h5 class="section-title">{{ selectedOption?.label }}</h5>-->
@if (useHeader()) {
    <app-header-divisor [label]="selectedOption?.label ?? ''" [icon]="selectedOption?.icon ?? ''">
        @if (selectedOption?.actions?.items && (selectedOption?.actions?.items?.length ?? -1) > 0) {
            <app-botao-acoes ngProjectAs="first-action-button" [items]="selectedOption?.actions?.items ?? []"></app-botao-acoes>
        }
        @if (useEditButton()) {
            <div ngProjectAs="second-action-button" class="flex gap-2">
                <ng-container [ngTemplateOutlet]="editControls"></ng-container>
            </div>
        }
        @for (customAction of customActions(); track customAction.label) {
            @if (!customAction.disabled) {
                <p-button label="{{ customAction.label }}" icon="{{ customAction.icon }}" (click)="customAction?.command ? $any(customAction).command() : null" />
            }
        }
    </app-header-divisor>
}
<div class="relative flex justify-center items-center pb-10">
    <p-select-button
        [options]="options()"
        [(ngModel)]="selected"
        [unselectable]="false"
        [multiple]="false"
        optionLabel="label"
        optionValue="value"
        (onChange)="onChange($event)"
        class="flex flex-wrap justify-center gap-2"
        styleClass="flex items-center"
    >
        <ng-template let-option pTemplate="item">
            <div class="flex items-center">
                <span>{{ option.label }}</span>
            </div>
        </ng-template>
    </p-select-button>
    <div class="absolute right-0 top-1/2 -translate-y-1/2 flex items-center gap-2">
        @if (!useHeader() && useEditButton()) {
            <ng-container [ngTemplateOutlet]="editControls"></ng-container>
        }
        <ng-content select="[tab-header-right]"></ng-content>
    </div>
</div>
<div class="section-wrapper">
    <ng-content></ng-content>
</div>

<!-- Controles de edição (Editar / Salvar / Cancelar) reutilizados no header e na barra de abas -->
<ng-template #editControls>
    <div class="flex gap-2">
        @if (!modoEdicao() && mostrarEntradaDeEdicao()) {
            @if (useEditActionsMenu()) {
                <app-botao-acoes [label]="'Ações'" [items]="editActions"></app-botao-acoes>
            } @else {
                <p-button label="Editar" icon="pi pi-pencil" (onClick)="habilitarEdicao()" />
            }
        }
        @if (modoEdicao()) {
            <p-button label="Salvar" icon="pi pi-check" (onClick)="salvarClicked()" [disabled]="disableEdit()" />
            <p-button label="Cancelar" icon="pi pi-times" severity="secondary" (onClick)="cancelarClicked()" />
        }
    </div>
</ng-template>
